import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessageField from 'components/field/MessageField/ErrorMessageField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const ConsumerCommunicationNotification = (props) => {
    const { data, translate } = props;

    if (utils.isEmpty(data)) {
        return null;
    }

    /**
     * When consumer communication is set to true,
     * then we return null;
     */
    if (data.consumer_communication) {
        return null;
    }

    return (
        <ErrorMessageField>
            { translate('resources.orders.information.consumer_communication') }
        </ErrorMessageField>
    );
};

ConsumerCommunicationNotification.propTypes = {
    data: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

export default translate(ConsumerCommunicationNotification);



// WEBPACK FOOTER //
// ./src/components/notifications/ConsumerCommunicationNotification.js